<template>
    <div>
        <div>
            <!-- <div class="content-table-title" style="margin-bottom: 20px">
                <span></span>
                <span>
                    <el-button type="primary" @click="Cart_ControlCabinetPackage_Add()">加入配柜到购物车</el-button>
                </span>
            </div> -->
            <div class="labelClassNameBox">
                <el-descriptions title="" :column="3" border labelClassName="labelClassName">
                    <el-descriptions-item label="型号">
                        <div class="rows">
                            <el-select v-model="cabinetForm.Product_Model" placeholder="请选择" @change="getProduct_Model" class="el-select-medium">
                                <el-option v-for="item in ControlCabinetCabinetPTList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="点位">
                        <div class="rows">
                            <el-select v-model="cabinetForm.Product_PT" placeholder="请选择" class="el-select-medium" @change="selectForm">
                                <el-option v-for="item in ControlCabinetModelPTList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="柜体">
                        <div class="rows">
                            <el-select v-model="cabinetForm.Product_Cabinet" placeholder="请选择" class="el-select-medium" @change="selectForm">
                                <el-option v-for="item in CabinetModelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="" span="3" v-if="addOriginalCabinetShow">
                        <div class="rows">
                            <div v-html="controlCabinetFormData.AddcabinetOptions.Resulttip"></div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item :label="item.Name" v-for="(item, index) in controlCabinetFormData.EleList" :key="index">
                        <div>
                            <div v-if="item.OptionTip">
                                {{ item.OptionTip }}
                            </div>
                            <div v-else-if="item.Code == 'BroadCastCard'">
                                {{ Object.values(item.Options)[0] }}
                            </div>
                            <div v-else-if="item.Code == 'CRT' || item.Code == 'TouchScreen' || item.Code == 'Network'">
                                <el-select v-model="item.OptionsValue" placeholder="无" class="el-select-medium">
                                    <el-option v-for="(value, key) in item.Options" :key="key" :label="value" :value="key"></el-option>
                                </el-select>
                            </div>
                            <div v-else-if="isEmpty(item.Battarys)">
                                <div v-for="(value, key) in item.Options" :key="key">
                                    <div>{{ value }}</div>
                                    <el-input v-model="item.Defaultval[key]" placeholder="请输入" clearable class="el-select-max"></el-input>
                                    <div style="margin: 5px 0" v-if="item.Name == '消防电源'">
                                        <span style="color: #cc0000; font-weight: 600">加配电池:</span>
                                        <el-select v-model="item.Battarys['d06_battery_' + key.split('D06Power_')[1]]" placeholder="请选择" style="width: 100px">
                                            <el-option label="0节" value="0"></el-option>
                                            <el-option label="2节" value="2"></el-option>
                                        </el-select>
                                    </div>
                                    <div style="margin: 5px 0" v-else>
                                        <span style="color: #cc0000; font-weight: 600">除标配外需加配电池:</span>
                                        <el-select v-model="item.Battarys['d06_battery_' + key.split('D06Power_')[1]]" placeholder="请选择" style="width: 100px">
                                            <el-option label="0套" value="0"></el-option>
                                            <el-option label="1套" value="1"></el-option>
                                            <el-option label="2套" value="2"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.Name == '手动盘'">
                                <el-radio-group v-model="Manual_ZX">
                                    <el-radio 
                                        v-for="(value, key, index) in item.Options" 
                                        :key="key" 
                                        :label="key"
                                        :checked="index === 0"
                                    >
                                        {{ value }}
                                        <div>
                                            <el-input v-model="item.Defaultval[key]" placeholder="请输入" clearable class="el-select-max"></el-input>
                                        </div>
                                    </el-radio>
                                </el-radio-group>
                            </div>
                            <div v-else-if="item.Code == 'Control'">
                                <div v-if="item.Options.KZKCard" style="margin: 5px 0">
                                    <!-- KZKCard选择器 -->
                                    <el-select v-model="item.Defaultval['KZKCard']" placeholder="请选择" style="width: 100px">
                                        <el-option label="无" value="0"></el-option>
                                        <el-option v-for="(optValue, optKey) in item.OptionsList.KZKCard" :key="optKey" :label="optKey" :value="optValue" :selected="optValue === item.Defaultval['KZKCard']"></el-option>
                                    </el-select>
                                    <span style="font-size: 12px; color: #999999">主机标配增补选项</span>
                                </div>
                                <!-- 非KZKCard字段 -->
                                <div v-for="(value, key) in item.Options" :key="key">
                                    <div v-if="key !== 'KZKCard'">{{ value }}</div>
                                    <el-input v-if="key !== 'KZKCard'" v-model="item.Defaultval[key]" placeholder="请输入" clearable class="el-select-max"></el-input>
                                </div>
                            </div>
                            <div v-else-if="isEmpty(item.Defaultval)">
                                <div v-for="(value, key) in item.Options" :key="key">
                                    <div v-if="item.Code != 'Outer_PowerAmount'">{{ value }}</div>
                                    <el-input v-model="item.Defaultval[key]" placeholder="请输入" clearable class="el-select-max"></el-input>
                                </div>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="提示" v-if="mainControllerShow" span="3">
                        <div>
                            {{ controlCabinetFormData.Message }}
                            <el-button v-for="(item, key) in controlCabinetFormData.MsgOptions" :key="key" type="primary" @click="buttonDispose(key)">{{ item }}</el-button>
                        </div>
                    </el-descriptions-item >
                    <el-descriptions-item label="提示"  v-if="cabinetControllerShow" span="3">
                        <b>
                            请输入原主控制器配置情况：
                        </b>
                    </el-descriptions-item>
                    <el-descriptions-item label="型号" v-if="cabinetControllerShow" span="3">
                        <el-select v-model="cabinetControllerForm.Product_Model1" placeholder="请选择" @change="getProduct_Model1" class="el-select-max">
                                <el-option v-for="item in ControlCabinetCabinetPTList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item label="点位" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-select v-model="cabinetControllerForm.Product_PT1" placeholder="请选择" class="el-select-max">
                                <el-option v-for="item in ControlCabinetModelPTList1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="手动盘数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.Manual_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="直接控制盘数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.Direct_Control_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="D02H电源盘数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.D02H_Power_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="D06H电源盘数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.D06H_Power_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="广播数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.Broadcast_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="150W功放数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.PowerAmplifier150_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="300W功放数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.PowerAmplifier300_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="500W功放数量" v-if="cabinetControllerShow" span="3">
                        <div>
                            <el-input v-model="cabinetControllerForm.PowerAmplifier500_Amount" placeholder="请输入" clearable class="el-select-max"></el-input>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="" v-if="cabinetControllerShow" span="3">
                        <el-button type="primary" @click="GetControlCabinetForm1">确定</el-button>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="automaticButton" v-if="controlCabinetFormData && isEmpty(controlCabinetFormData.EleList)">
                <el-button type="primary" @click="GetControlCabinetResultShow()">自动配柜</el-button>
                <el-button type="primary" @click="GetControlCabinetForm(1)">删除当前配置信息</el-button>
            </div>
            <div v-if="controlCabinetResultList && controlCabinetResultList.length > 0" style="margin-top: 20px">
                <el-table :data="filteredControlCabinetResultList" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column prop="CabinetNoTip" label="柜号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="SaleGroup" label="销售组" align="center"></el-table-column>
                    <el-table-column prop="ProductName" label="商品名称" align="center" width="400" show-overflow-tooltip>
                        <template v-slot="scope">
                            <div v-if="scope.row.D06BatteryTip">
                                <span>
                                    {{ scope.row.ProductName }}
                                </span>
                                <br />
                                <span style="color: #cc0000; font-weight: 600" v-if="Object.keys(scope.row.D06batterySelectArry).length == 0">
                                    {{ scope.row.D06BatteryTip }}
                                </span>
                                <span v-else>
                                    <span style="color: #cc0000; font-weight: 600">{{ scope.row.D06BatteryTip }}</span>
                                    <el-select @change="setD06battery(scope.row)" v-model="scope.row[scope.row.D06batterySelectName]" placeholder="请选择" class="el-select-medium">
                                        <el-option v-for="(value, key) in scope.row.D06batterySelectArry" :key="key" :label="key" :value="value"></el-option>
                                    </el-select>
                                </span>
                            </div>
                            <div v-else>{{ scope.row.ProductName }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ProductSpec" label="规格" align="center"></el-table-column>
                    <el-table-column prop="ProductPrice" label="单价" align="center">
                        <template v-slot="scope">
                            <div>￥{{ scope.row.ProductPrice }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Amount" label="数量" align="center" width="150"></el-table-column>
                    <el-table-column prop="prop" label="合计" align="center">
                        <template v-slot="scope">
                            <div>￥{{ (scope.row.ProductPrice * scope.row.Amount).toFixed(2) }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else-if="btnList" style="margin-top: 20px; text-align: center">
                {{ controlCabinetTxt }}
                <el-button v-for="(value, key) in this.btnList.bts" :key="key" type="primary" @click="GetControlCabinetResultShow(btnList.optKey, value)">
                    {{ key }}
                </el-button>
            </div>
            <div v-else-if="controlCabinetTxt" style="margin-top: 20px; text-align: center">
                {{ controlCabinetTxt }}
            </div>
        </div>
    </div>
</template>

<script>
import { set } from 'lodash';

export default {
    props: {
        Orders_Type: {
            type: [String, Number],
            default: 0
        },
        Orders_SourceCate: {
            type: [String, Number],
            default: 0
        },
        shoppingCarts: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            controlCabinetFormData: {
                EleList: [],
                AddcabinetOptions: {
                    Resulttip: ''
                }
            }, //配柜信息
            offlineCabinetList: [], // 配柜业务员
            ControlCabinetCabinetPTList: [], // 配柜型号
            ControlCabinetModelPTList: [], // 配柜点位
            CabinetModelList: [
                {
                    value: '',
                    label: '请选择'
                }
            ], // 配柜柜体
            cabinetForm: {
                Product_Model: '', // 配柜型号
                Product_PT: '', // 配柜点位
                Product_Cabinet: '' // 配柜柜体
            },
            Manual_ZX: '', //手动盘选项
            mainControllerShow: false, //没有主控器显示
            cabinetControllerForm: {
                Product_Model1: '',
                Product_PT1: '',
                Manual_Amount: 0, // 手动盘数量
                Direct_Control_Amount: 0, // 直接控制盘数量
                D02H_Power_Amount: 0, // D02H电源盘数量
                D06H_Power_Amount: 0, // D06H电源盘数量
                Broadcast_Amount: 0, // 广播数量
                PowerAmplifier150_Amount: 0, // 150瓦功放数量
                PowerAmplifier300_Amount: 0, // 300瓦功放数量
                PowerAmplifier500_Amount: 0 // 500瓦功放数量
            }, // 没有主控器时配柜主控器信息
            cabinetControllerShow: false, // 配柜主控器显示
            addOriginalCabinetShow: false, // 原始配柜提示显示
            ControlCabinetModelPTList1: [], // 配柜点位
            controlCabinetResultList: [], // 配柜结果
            controlCabinetTxt: '', // 配柜结果
            SourceConfig: '', // 配柜
            btnList: {
                optKey: '',
                bts: {}
            }, //!=000000 时的返回信息
            HiddeFromResultInfo: {}
        };
    },
    computed: {
        filteredControlCabinetResultList() {
            return this.controlCabinetResultList.filter((item) => item.ItemType !== 6);
        }
    },
    mounted() {
        this.GetControlCabinetProductModel();
        this.GetControlCabinetProductCanbinet();
    },
    methods: {
        isEmpty(value) {
            if (value == null) return false; // 处理 null 和 undefined
            if (typeof value === 'boolean') return value; // 直接返回布尔值
            if (typeof value === 'number') return value !== 0 && !isNaN(value); // 0 和 NaN 为 false
            if (typeof value === 'string') return value.trim() !== ''; // 空字符串为 false
            if (Array.isArray(value)) return value.length > 0; // 空数组为 false
            if (typeof value === 'object') return Object.keys(value).length > 0; // 空对象为 false
            return true; // 其他情况默认认为是 true
        },
        // 点位
        GetControlCabinetModelPT() {
            let json = JSON.stringify({
                Product_Model: this.cabinetForm.Product_Model
            });
            this.$newsApi.order.GetControlCabinetModelPT({ json: json }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.ControlCabinetModelPTList = res.data.data.map((item) => {
                        return {
                            value: item,
                            label: item
                        };
                    });
                    this.ControlCabinetModelPTList.unshift({
                        value: '',
                        label: '无'
                    });
                }
            });
        },
        GetControlCabinetModelPT1() {
            let json = JSON.stringify({
                Product_Model: this.cabinetControllerForm.Product_Model1
            });
            this.$newsApi.order.GetControlCabinetModelPT({ json: json }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.ControlCabinetModelPTList1 = res.data.data.map((item) => {
                        return {
                            value: item,
                            label: item
                        };
                    });
                    this.ControlCabinetModelPTList1.unshift({
                        value: '',
                        label: '无'
                    });
                }
            });
        },
        // 型号
        GetControlCabinetProductModel() {
            this.$newsApi.order.GetControlCabinetProductModel().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.ControlCabinetCabinetPTList = res.data.data.map((item) => {
                        return {
                            value: item,
                            label: item
                        };
                    });
                    this.ControlCabinetCabinetPTList.unshift({
                        value: '',
                        label: '无'
                    });
                }
            });
        },
        // 柜体
        GetControlCabinetProductCanbinet() {
            this.$newsApi.order.GetControlCabinetProductCanbinet().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.CabinetModelList = res.data.data.map((item) => {
                        return {
                            value: item,
                            label: item
                        };
                    });
                    this.CabinetModelList.unshift({
                        value: '',
                        label: '无'
                    });
                }
            });
        },

        getProduct_Model() {
            this.cabinetForm.Product_PT = '';
            if (this.cabinetForm.Product_Model) {
                this.GetControlCabinetModelPT();
            } else {
                this.ControlCabinetModelPTList = [];
            }
            this.cabinetControllerForm = {
                Product_Model1: '',
                Product_PT1: '',
                Manual_Amount: 0, // 手动盘数量
                Direct_Control_Amount: 0, // 直接控制盘数量
                D02H_Power_Amount: 0, // D02H电源盘数量
                D06H_Power_Amount: 0, // D06H电源盘数量
                Broadcast_Amount: 0, // 广播数量
                PowerAmplifier150_Amount: 0, // 150瓦功放数量
                PowerAmplifier300_Amount: 0, // 300瓦功放数量
                PowerAmplifier500_Amount: 0 // 500瓦功放数量
            };
            this.cabinetControllerShow = false;
            this.GetControlCabinetForm('', 1);
        },
        getProduct_Model1() {
            console.log(this.cabinetControllerForm.Product_Model1);
            if (this.cabinetControllerForm.Product_Model1) {
                this.GetControlCabinetModelPT1();
            } else {
                this.ControlCabinetModelPTList1 = [];
                this.cabinetControllerForm.Product_PT1 = '';
            }
        },
        selectForm() {
            this.GetControlCabinetForm();
        },
        setD06battery(row) {},
        async GetControlCabinetForm(e, i) {
            this.controlCabinetTxt = '';
            this.btnList = {};
            this.SourceConfig = '';
            this.controlCabinetResultList = [];
            this.addOriginalCabinetShow = false;
            let data = this.GetControlCabinetObj(e);
            if (i) {
                data.clear = 1;
            }
            let json = JSON.stringify(data);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.GetControlCabinetForm({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            this.controlCabinetFormData = result.data.data || {};
            if (this.controlCabinetFormData.Message) {
                this.mainControllerShow = true;
            } else {
                this.mainControllerShow = false;
            }
            if (this.controlCabinetFormData.EleList && this.controlCabinetFormData.EleList.length > 0) {
                this.controlCabinetFormData.EleList = this.controlCabinetFormData.EleList.map((item) => {
                    if (item.Code == 'CRT' || item.Code == 'TouchScreen' || item.Code == 'Network') {
                        this.$set(item, 'OptionsValue', Object.keys(item.Defaultval)[0] || '0');
                    }
                    if (item.Name === '消防电源' && item.Battarys) {
                        for (const key in item.Battarys) {
                            if (key.startsWith('d06_battery_')) {
                                // 设置默认值为0
                                this.$set(item.Battarys, key, item.Defaultval[key]);
                            }
                        }
                    }
                    return item;
                });
            }
            const ManualZXOptions = this.controlCabinetFormData.EleList ? this.controlCabinetFormData.EleList.find((item) => item.Name == '手动盘').Options || '' : '';
            this.Manual_ZX = this.getFirstKey(ManualZXOptions);
        },
        buttonDispose(e) {
            if (e) {
                this.GetControlCabinetForm1();
            } else {
                this.cabinetForm = {
                    Product_Model: '', // 配柜型号
                    Product_PT: '', // 配柜点位
                    Product_Cabinet: '' // 配柜柜体
                };
            }
            this.mainControllerShow = false;
        },
        // 没有主控制器时
        async GetControlCabinetForm1() {
            this.controlCabinetTxt = '';
            this.btnList = {};
            this.SourceConfig = '';
            this.controlCabinetResultList = [];
            let AddCabinetConfirm = 0;
            if(Object.keys(this.controlCabinetFormData.HiddeFromResultInfo).length > 0){
                AddCabinetConfirm = 1;
            }
            let data = {
                ...this.cabinetForm,
                Product_AddCabinet: 1,
                AddCabinetConfirm: AddCabinetConfirm,
                Orders_Type: this.Orders_Type,
                Orders_SourceCate: this.Orders_SourceCate,
                ...this.cabinetControllerForm
            };
            let json = JSON.stringify(data);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.GetControlCabinetForm({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            this.controlCabinetFormData = result.data.data || {};
            this.HiddeFromResultInfo = this.controlCabinetFormData.HiddeFromResultInfo;
            
            let hasMessage = !!this.controlCabinetFormData.Message;
            if(this.controlCabinetFormData.MsgOptions && Object.keys(this.controlCabinetFormData.MsgOptions).length > 0){
                hasMessage = false;
                this.mainControllerShow = true;
            }
            if(this.controlCabinetFormData.EleList && this.controlCabinetFormData.EleList.length > 0){
                this.controlCabinetFormData.EleList.forEach((item) => {
                    if (item.Name == '手动盘') {
                        const firstKey = Object.keys(item.Options)[0];
                        this.Manual_ZX = firstKey || '';
                    }
                })
            }
            if(!this.mainControllerShow){
                    this.cabinetControllerForm = {
                    Product_Model1: this.controlCabinetFormData.Product_Model1 || '',
                    Product_PT1: this.controlCabinetFormData.Product_PT1 || '',
                    Manual_Amount: this.controlCabinetFormData.Manual_Amount || 0,
                    Direct_Control_Amount: this.controlCabinetFormData.Direct_Control_Amount || 0,
                    D02H_Power_Amount: this.controlCabinetFormData.D02H_Power_Amount || 0,
                    D06H_Power_Amount: this.controlCabinetFormData.D06H_Power_Amount || 0,
                    Broadcast_Amount: this.controlCabinetFormData.Broadcast_Amount || 0,
                    PowerAmplifier150_Amount: this.controlCabinetFormData.PowerAmplifier150_Amount || 0,
                    PowerAmplifier300_Amount: this.controlCabinetFormData.PowerAmplifier300_Amount || 0,
                    PowerAmplifier500_Amount: this.controlCabinetFormData.PowerAmplifier500_Amount || 0
                };
            }
            this.cabinetControllerShow = hasMessage;
            this.addOriginalCabinetShow = !hasMessage;
        },
        // 确定
        cabinetControlOK() {},
        // handleCabinetOption(key, value) {
        //     let data = this.GetControlCabinetObj();

        //     let json = JSON.stringify(data);
        //     this.GetControlCabinetResultShow(json);
        // },
        // 自动配柜
        async GetControlCabinetResultShow(key = '', val = '') {
            if(!this.addOriginalCabinetShow){
                await this.GetControlCabinetForm();
            }

            this.controlCabinetTxt = '';
            this.btnList = {};
            this.SourceConfig = '';
            this.controlCabinetResultList = [];

            let data = this.GetControlCabinetObj();
        
            if (this.addOriginalCabinetShow) {
                data = {
                    ...data,
                    Product_AddCabinet: 1,
                    ...this.HiddeFromResultInfo
                };
            }
            if (key) {
                data[key] = val;
            }
            if (this.Manual_ZX) {
                data['Manual'] = this.Manual_ZX.split('_')[1];
            }
            let json = JSON.stringify(data);
            let loadingInstance = this.$loading(); // 显示 loading
            let result = await this.$newsApi.order.GetControlCabinetResultShow({ json: json });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.data.Resultcode != 0) {
                this.controlCabinetResultList = [];
                this.controlCabinetTxt = result.data.Resultinfo || '';
                return;
            }
            this.SourceConfig = result.data.data.ControlCabinetResultList.Message;
            if (result.data.data.ControlCabinetResultList.Code != '000000') {
                if (result.data.data.ControlCabinetResultList.Code === '000001') {
                    this.controlCabinetResultList = [];
                    this.controlCabinetTxt = result.data.Resultinfo || '';
                } else if (result.data.data.ControlCabinetResultList.Code === '000002' || result.data.data.ControlCabinetResultList.Code === '000003' || result.data.data.ControlCabinetResultList.Code === '000004' || result.data.data.ControlCabinetResultList.Code === '000005' || result.data.data.ControlCabinetResultList.Code === '000006' || result.data.data.ControlCabinetResultList.Code === '000007' || result.data.data.ControlCabinetResultList.Code === '000008') {
                    this.controlCabinetTxt = result.data.data.ControlCabinetResultList.Tip || '';
                    this.btnList.optKey = Object.keys(result.data.data.ControlCabinetResultList.BtnList)[0];
                    this.btnList.bts = result.data.data.ControlCabinetResultList.BtnList[this.btnList.optKey];
                }
                return;
            } else {
                this.controlCabinetResultList = result.data.data.ControlCabinetResultList.goodstmps || [];
                this.controlCabinetResultList = this.controlCabinetResultList.map((item) => {
                    const key = item.D06batterySelectName || 'default';
                    return {
                        ...item,
                        [key]: 0
                    };
                    // let Product_Price = 0;
                    // let ProductTypes = '';
                    // if (result.data.data.DefaultPriceListDetails) {
                    //     let defaultPrice = result.data.data.DefaultPriceListDetails.find((item1) => {
                    //         return item1.Detail_ProductID == item.ProductID;
                    //     });
                    //     Product_Price = defaultPrice ? defaultPrice.Detail_Price : 0;
                    // }
                    // if (result.data.data.ProductTypes) {
                    //     ProductTypes = result.data.data.ProductTypes[item.ProductTypeID];
                    // }
                    // return {
                    //     ...item,
                    //     [item.D06batterySelectName]: 0
                    // };
                });
            }
        },
        // 参数配置
        GetControlCabinetObj(e) {
            let dataObj = {};
            // this.addOriginalCabinetShow = false;
            if (this.controlCabinetFormData.EleList && this.controlCabinetFormData.EleList.length > 0 && !e) {
                this.controlCabinetFormData.EleList.forEach((item) => {
                    if (item.Code == 'BroadCastCard') {
                        dataObj[item.Code] = Object.keys(item.Options)[0];
                    } else if (item.Code == 'CRT' || item.Code == 'TouchScreen' || item.Code == 'Network') {
                        dataObj[item.Code] = item.OptionsValue;
                    } else {
                        if (this.isEmpty(item.Defaultval)) {
                            dataObj = {
                                ...dataObj,
                                ...item.Defaultval
                            };
                        }
                        if (this.isEmpty(item.Battarys)) {
                            dataObj = {
                                ...dataObj,
                                ...item.Battarys
                            };
                        }
                    }
                });
            }
            let data = {
                ...this.cabinetForm,
                Product_AddCabinet: 0,
                AddCabinetConfirm: 0,
                Orders_Type: this.Orders_Type,
                Orders_SourceCate: this.Orders_SourceCate,
                ...dataObj
            };
            return data;
        },
        // 加入配柜
        async Cart_ControlCabinetPackage_Add() {
            let json = JSON.stringify(this.controlCabinetResultList);
            const dynamicFields = this.controlCabinetResultList.reduce((acc, item) => {
                const key = item.D06batterySelectName;
                if (key && item[key] !== undefined) {
                    acc[key] = item[key] || item.BatteryAmount;
                }
                return acc;
            }, {});
            let obj = {
                Product_PT: this.cabinetForm.Product_PT,
                Product_Model: this.cabinetForm.Product_Model,
                Product_Cabinet: this.cabinetForm.Product_Cabinet,
                Product_PT1: this.cabinetControllerForm.Product_PT1,
                Product_Model1: this.cabinetControllerForm.Product_Model1,
                Product_AddCabinet: this.mainControllerShow ? 1 : 0,
                CabinGoodsList: json,
                SourceConfig: this.SourceConfig || '',
                ...dynamicFields
            };
            if (this.addOriginalCabinetShow) {
                obj = {
                    ...obj,
                    Product_AddCabinet: 1,
                    ...this.HiddeFromResultInfo
                };
            }
            this.$emit('Cart_ControlCabinetPackage_Add', obj);
        },
        searchShoppingCart() {
            this.$emit('searchShoppingCart');
        },
        getFirstValue(obj) {
            const keys = Object.keys(obj);
            if (keys.length === 0) {
                return '';
            }
            return obj[keys[0]];
        },
        getFirstKey(obj) {
            const keys = Object.keys(obj);
            if (keys.length === 0) {
                return '';
            }
            return keys[0];
        },
        getBattaryType() {
            return this.controlCabinetFormData.EleList.find((item) => item.Name == '消防电源');
        }
    }
};
</script>

<style>
.automaticButton {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    align-items: center;
}

.el-descriptions-item__cell {
    display: table-cell !important;
    align-content: center !important;
    vertical-align: middle;
}
.el-scrollbar__wrap {
    overflow-x: auto;
  
    margin-right: 0;
    margin-bottom: 0;
}
.el-scrollbar__bar {
    display: none !important;
}

/* 修复el-select下拉框滚动条显示问题 - 确保显示一个可见的滚动条 */
.el-select-dropdown {
    /* 允许下拉框正常显示内容 */
    overflow: visible !important;
}

.el-select-dropdown .el-scrollbar {
    height: 100% !important;
}

.el-select-dropdown .el-scrollbar__wrap {
    /* 允许垂直滚动，隐藏水平滚动 */
    overflow-y: auto !important;
    overflow-x: hidden !important;
    margin-right: 0 !important;
    margin-bottom: 0 !important;
    max-height: 274px;
}

.el-select-dropdown .el-scrollbar__view {
    /* 确保内容可以正常显示 */
    overflow: visible;
}

/* 隐藏Element UI的滚动条组件，使用原生滚动条 */
.el-select-dropdown .el-scrollbar__bar {
    display: none !important;
}

/* 自定义原生滚动条样式 */
.el-select-dropdown .el-scrollbar__wrap::-webkit-scrollbar {
    width: 6px;
}

.el-select-dropdown .el-scrollbar__wrap::-webkit-scrollbar-track {
    background: transparent;
}

.el-select-dropdown .el-scrollbar__wrap::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.3);
    border-radius: 3px;
}

.el-select-dropdown .el-scrollbar__wrap::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144, 147, 153, 0.5);
}
</style>